<template>
  <section v-on:click="headerClicked">
    <header :class="{showMenuMobile: showMenuMobile}">
      <div class="logoCnt">
        <div class="logo" v-if="category">
          <a href="/">
            <img src="../assets/amway-logo-black.svg">
            <span class="span1">Content Hub</span>
          </a>
          <a :href="`/${category.slug}?u=${this.uuid}`">
            <span>{{category.name}}</span>
          </a>
        </div>
        <div class="logo" v-else>
          <a href="/">
            <img src="../assets/amway-logo-black.svg">
            <span class="span1">Content Hub</span>
          </a>
        </div>
      </div>
      <div :class="{searchCnt: true, open: searchOpen}">
        <form v-on:submit.prevent="search" action="/search"
          :class="{searchLoading: searchLoading}">
          <input type="text" placeholder="Cari publikasi..."
            name="q" autocomplete="off" spellcheck="off" v-model="query"
            ref="search" v-on:input="search" v-on:focus="search" v-on:click.stop="doNothing">
          <div class="searchLoading"></div>
          <div class="closeSearch" v-on:click="searchOpen = false"></div>
          <button type="submit"></button>
        </form>
        <div class="searchOverlay" v-if="viewSearchDd"></div>
        <perfect-scrollbar class="searchDd" v-if="viewSearchDd">
          <div class="searchLoading" v-if="searchLoading"></div>
          <div class="notFound" v-else-if="searchResults.length < 1">
            <h4>Tidak ada hasil ditemukan</h4>
            <p>Apa yang kamu cari sepertinya tidak ada, coba ganti kata kunci pencarian.</p>
          </div>
          <div v-else>
            <li v-for="(item, i) in searchResults" :key="i"
              :class="item.type" v-on:click.stop="openSearch(item)">
              <div class="icon" :style="{'background-image': `url(${item.thumb})`}"></div>
              {{item.name}}
              <div class="label" v-if="item.label">{{item.label}}
                <span v-if="item.page">&bull; Page {{item.page}}</span>
              </div>
            </li>
          </div>
        </perfect-scrollbar>
      </div>
      <div class="menuCnt" :class="{open: menuOpen}">
        <li><a href="/amagram">Amagram</a></li>
        <div class="loadingBsm" v-if="loadingBsm"></div>
        <li v-for="(item, i) in bsm" :key="i">
          <a :href="`/category/${item.slug}`">{{item.name}}</a>
          <div class="submenu" v-if="item.submenu && item.submenu.length > 0">
            <li v-for="(submenu, isub) in item.submenu" :key="isub">
              <a :href="`/${submenu.slug}`">{{submenu.name}}</a>
            </li>
          </div>
        </li>
      </div>
      <div class="menuOverlay" v-if="menuOpen"
        v-on:click.stop="menuOpen = false"></div>
      <!--
      <div class="menuToggle" :class="{open: menuOpen}"
        v-on:click.stop="menuOpen = !menuOpen"></div>
      -->
      <div class="signInCnt">
        <div class="userPict" v-if="loggedIn"
          v-on:click.stop="doNothing">
          <div :class="{headerPict: 1, hasPhoto: $session.get('avatar')}"
            :style="{'background-image': `url(${$session.get('avatar')})`}"
            v-on:click.stop="showMenu = true">
            <span>{{$session.get('am_ct_hub_name').substr(0,2)}}</span>
          </div>
          <div class="userMenu" v-if="showMenu">
            <div class="pictCnt">
              <div :class="{thePict: 1, hasPhoto: $session.get('avatar')}"
                :style="{'background-image': `url(${$session.get('avatar')})`}">
                <span>{{$session.get('am_ct_hub_name').substr(0,2)}}</span>
              </div>
            </div>
            <h4>{{$session.get('am_ct_hub_name')}}</h4>
            <h5>ABO {{$session.get('am_ct_hub_abo_no')}}</h5>
            <!--
            <div class="infoTmp">
              <div style="background-color: red; position: absolute;
                padding: 4px 10px; right: 16px; top: -8px;">Will not visible</div>
              <div class="infoTmpItem">
                Level: <b>{{$session.get('am_ct_hub_level')}}</b>
              </div>
              <div class="infoTmpItem">
                Acct_type: <b>{{$session.get('am_ct_hub_acct_type')}}</b>
              </div>
              <div class="infoTmpItem">
                Acct_subtype: <b>{{$session.get('am_ct_hub_acct_subtype')}}</b>
              </div>
            </div>
            -->
            <!-- <div class="divider"></div> -->
            <!-- <li>Konten Favorit</li> -->
            <!-- <div class="divider"></div> -->
            <li v-on:click.stop="signOut">Keluar</li>
          </div>
        </div>
        <button class="signIn" v-else v-on:click="openLogin">Masuk</button>
        <div class="actIcon search" v-on:click="openSearchView"></div>
        <div class="actIcon menuMobile" v-on:click.stop="menuOpen = !menuOpen"></div>
      </div>
    </header>
    <Confirmation ref="confirmDialog"/>
  </section>
</template>

<script>
import { nanoid } from 'nanoid'; // eslint-disable-line
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'header',
  components: { Confirmation },
  data() {
    return {
      showMenuMore: false,
      showMenuMobile: false,
      showMenu: false,
      menuOpen: false,
      viewSearchDd: false,
      notifOpen: false,
      unread: 0,
      searchResults: [],
      searchLoading: false,
      searchTimer: null,
      query: '',
      searchOpen: false,
      uuid: '',
      bsm: [],
      loadingBsm: true,
      loggedIn: false,

      /**
       * Auth
       *
       */
      authRedirect: 'https://contenthub.amway.id/auth/redirect',
      authCanceled: '',
      authCliendId: '0oaptnbl8qSLB49hv1t7',
      authClientApp: 'contenthub-ID',

      /**
       * Okta
       *
       */
      authUri: 'https://account.amwayglobal.com/v1/proxy/oauth2/ausbw9tp2iqCJklAw1t7/v1/',
      authSignoutUri: 'https://account.amwayglobal.com/signout',

      /**
       * Gluu
       *
       */
      // authUri: 'https://account-apacreg-qa2.amwayglobal.com/v1/proxy/oauth2/ausnmpoj9bWKNVHVk0h7/v1/',
      // authSignoutUri: 'https://account-apacreg-qa2.amwayglobal.com/signout',
    };
  },
  props: ['category'],
  methods: {
    doNothing() {},
    search(e) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        if (!this.query || this.query === '') {
          this.searchLoading = false;
          this.viewSearchDd = false;
          return;
        }
        this.searchLoading = true;
        const sUri = (this.category) ? `misc/${this.category.id}/search` : 'misc/search';
        this.$http.post(this.$config.uri(sUri), {
          q: this.query,
        }).then((r) => {
          this.searchResults = (r.data.status === 200) ? r.data.data : [];
          this.searchLoading = false;
          this.viewSearchDd = true;
        });
      }, 500);
    },
    signOut() {
      this.$session.destroy();
      // window.location.href = '/';
      window.location.href = `${this.authSignoutUri}?clientapp=${this.authClientApp}`
        + `&redirect=${encodeURIComponent(this.authRedirect)}`;
    },
    openLogin() {
      const nonce = nanoid();
      const state = nanoid(10);
      localStorage.setItem('oauth_state', state);
      const stateObj = {
        amw_lng: 'en-us',
        amw_clientapp: this.authClientApp,
        uri: this.$route.fullPath,
        u: state,
      };
      const stateEncoded = encodeURIComponent(btoa(JSON.stringify(stateObj)));
      const loginUrl = `${this.authUri}authorize?response_mode=query&response_type=code`
        + `&scope=openid%20offline_access%20profile%20account_profile&nonce=${nonce}`
        + `&state=${stateEncoded}&redirect_uri=${encodeURIComponent(this.authRedirect)}`
        + `&cancelredirect=${encodeURIComponent(this.authCanceled)}&client_id=${this.authCliendId}`;
      window.location.href = loginUrl;
    },
    headerClicked() {
      this.viewSearchDd = false;
      this.notifOpen = false;
      this.menuOpen = false;
      this.showMenu = false;
    },
    openSearchView() {
      this.searchOpen = true;
      setTimeout(() => {
        this.$refs.search.focus();
      });
    },
    openSearch(item) {
      this.viewSearchDd = false;
      if (!item.url) return;
      const p = (item.page) ? `&p=${item.page}` : '';
      const url = `${item.url}?u=${this.uuid}${p}`;
      window.location.href = url;
    },
  },
  watch: {
    $route() {
      this.showMenuMore = false;
      // setTimeout(() => {
      this.showMenuMobile = false;
      // }, 300);
    },
  },
  mounted() {
    this.uuid = this.$route.query.u || '';
    this.$http.get(this.$config.uri('content/parent/bsm/ok?submenu=y')).then((r) => {
      this.loadingBsm = false;
      this.bsm = (r.data.status === 200) ? r.data.data : [];
    });

    this.loggedIn = (this.$session.get('am_ct_hub_logged_in')) ? true : false; // eslint-disable-line
    if (this.loggedIn) {
      const jwt = this.$session.get('am_ct_hub_logged_in');
      if (!jwt) {
        this.$refs.confirmDialog.open({
          title: 'Sesi Sudah Habis',
          desc: 'Sesi akun kamu sudah habis, dan kamu otomatis keluar, apakah ingin masuk lagi?',
          action: 'Masuk Lagi',
        }, (b) => {
          if (!b) {
            this.$session.destroy();
            window.location.reload();
            return;
          }
          this.$session.destroy();
          this.openLogin();
        });
        // return;
      }
      // this.$http.get(this.$config.uri('user/status/sso'), {
      //   headers: {
      //     Authorization: jwt,
      //   },
      // }).then((r) => {
      //   if (r.data.status !== 200) {
      //     this.$session.destroy();
      //     this.$refs.confirmDialog.open({
      //       title: 'Sesi Sudah Habis',
      //       desc: 'Sesi akun kamu sudah habis, dan kamu
      // otomatis keluar, apakah ingin masuk lagi?',
      //       action: 'Masuk Lagi',
      //     }, (b) => {
      //       if (!b) {
      //         window.location.reload();
      //         return;
      //       }
      //       this.openLogin();
      //     });
      //   }
      // });
    }
  },
};
</script>

<style scoped lang="scss">
header{
  position: fixed;
  left: 0; right: 0; top: 0;
  z-index: 99;
  background-color: #002f5f;
  color: #444;
  display: flex;
  padding: 10px 20px;
  height: 64px;
  box-sizing: border-box;
  font-family: 'Hind Siliguri', sans-serif;
  line-height: 1.3;

  /**
   * White version
   *
   */
  background-color: #fff;
  box-shadow: 0 0 5px rgba(0,0,0,.2);
  @media (max-width: 760px) {
    height: 54px;
    padding: 9px 10px;
  }
  a{
    color: #fff;
    text-decoration: none;
  }
  .menuToggle{
    width: 40px; height: 40px;
    border-radius: 50%;
    margin-top: 2px;
    background-image: url(../assets/menu.png);
    background-size: 20px auto;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    transition: all .3s ease;
    opacity: .7;
    margin-left: 10px;
    z-index: 91;
    display: none;
    @media (max-width: 1190px) {
      display: block;
    }
    @media (max-width: 760px) {
      margin-top: -2px;
    }
    &.open{
      background-image: url(../assets/close.png);
      background-size: 16px auto;
    }
    &:hover{
      opacity: 1;
      background-color: #eee;
    }
  }
  .menuCnt{
    display: flex;
    padding-top: 10px;
    margin-right: -10px;
    @media (max-width: 1190px) {
      position: fixed;
      z-index: 9992;
      display: block;
      background-color: #fff;
      padding: 10px 0;
      margin: 0;
      right: -300px; top: 0; bottom: 0;
      width: 300px;
      transition: all .3s ease;
      overflow-y: auto;
      &.open{
        right: 0;
      }
    }
    .loadingBsm{
      width: 180px;
      height: 26px;
      border-radius: 50px;
      background-color: #f5f5f5;
    }
    li{
      list-style: none;
      position: relative;
      @media (max-width: 1190px) {
        margin: 20px 0 0;
      }
      a{
        color: #444;
        font-weight: 600;
        padding: 8px 20px;
        border-radius: 50px;
        transition: all .3s ease;
        font-size: 18px;
        white-space: nowrap;
        @media (max-width: 1190px) {
          background: none !important;
        }
        &:hover{
          background-color: #f5f5f5;
        }
      }
      .submenu{
        position: absolute;
        left: 50%; top: 98%;
        transform: translateX(-50%);
        background-color: #fff;
        padding: 10px 0;
        border-radius: 5px;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, .2);
        display: none;
        @media (max-width: 1190px) {
          transform: none;
          position: static;
          display: block;
          background-color: #f5f5f5;
          box-shadow: none;
          padding: 5px 0;
          margin: 5px 10px 0;
        }
        li{
          @media (max-width: 1190px) {
            margin: 0;
          }
          a{
            display: block;
            white-space: nowrap;
            border-radius: 0;
            font-size: 16px;
            font-weight: normal;
            padding: 10px 26px;
            box-sizing: border-box;
            min-width: 180px;
            @media (max-width: 1190px) {
              padding: 5px 20px;
            }
          }
        }
      }
      &:hover{
        .submenu{
          display: block;
        }
      }
    }
  }
  .searchOverlay{
    position: fixed;
    left: 0; top: 64px; right: 0; bottom: 0;
    background-color: #000;
    opacity: .5;
    z-index: 1;
    @media (max-width: 760px) {
      top: 54px;
    }
  }
  .searchCnt{
    padding-right: 10px;
    width: 100%;
    position: relative;
    max-width: 400px;
    margin: 0 auto;
    padding-top: 2px;

    /**
     * New
     *
     */
    padding: 0;
    width: 600px;
    max-width: none;
    margin-right: 10px;
    z-index: 999;
    @media (max-width: 1560px) {
      width: 500px;
    }
    @media (max-width: 1360px) {
      width: 360px;
    }
    .searchDd{
      background-color: #fff;
      position: absolute;
      top: 100%; right: 10px; left: 0;
      border-radius: 10px;
      box-shadow: 2px 2px 4px rgba(0,0,0,.2);
      margin-top: 4px;
      padding: 10px 0;
      font-size: 17px;
      z-index: 2;
      max-height: 400px;
      .searchLoading{
        height: 160px;
        background-image: url(../assets/loading.svg);
        background-size: 40px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      .notFound{
        color: #444;
        padding: 30px 20px;
        position: static;
        transform: none;
        h4{
          margin: 0 0 6px;
          font-weight: normal;
          font-size: 24px;
        }
        p{
          margin: 0;
          font-size: 15px;
          line-height: 1.4;
          color: #767676;
        }
      }
      li{
        list-style: none;
        padding: 10px 20px;
        cursor: pointer;
        position: relative;
        padding-left: 60px;
        line-height: 1.4;
        .label{
          color: #767676;
          font-size: 14px;
          margin-top: -2px;
        }
        .icon{
          position: absolute;
          left: 20px; top: 12px;
          width: 24px; bottom: 12px;
          background-image: url(../assets/search.png);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
        }
        &:hover{
          background-color: #f5f5fe;
        }
        &.category{
          padding-left: 50px;
          .icon{
            background-image: url(../assets/empty-folder.svg);
            width: 20px; height: 20px;
            top: 9px; left: 20px;
          }
        }
        &.header{
          text-transform: uppercase;
          color: #888;
          font-weight: 500;
          font-size: 12px;
          padding: 16px 20px 6px;
          cursor: default;
          &:hover{
            background-color: #fff;
          }
          .icon{
            display: none;
          }
        }
      }
      @media (max-width: 760px) {
        right: 0;
        border-radius: 0;
        margin-top: 0;
        max-height: none;
        overflow: visible;
      }
    }
    form{
      position: relative;
      .searchLoading{
        position: absolute;
        width: 30px; height: 30px;
        border: none; border-radius: 50%;
        top: 5px; right: 10px;
        background-image: url(../assets/loading.svg);
        background-size: 22px auto;
        background-position: center;
        background-repeat: no-repeat;
        display: none;
      }
      &.searchLoading{
        button{
          display: none;
        }
        .searchLoading{
          display: block;
        }
      }
      input{
        border: #00468e 2px solid;
        background-color: #00468e;
        box-shadow: none;
        border-radius: 40px;
        padding: 6px 20px;
        padding-right: 50px;
        text-overflow: ellipsis;
        font-size: 18px;
        outline: 0 !important;
        line-height: 1;
        width: 100%;
        box-sizing: border-box;
        transition: all .3s ease;

        /**
         * New
         *
         */
        padding: 7px 20px 6px;
        @media (max-width: 760px) {
          padding: 7px 20px 6px;
        }
        &:hover{
          border-color: #002f5f;
        }
        &:focus{
          border-color: #fff;
          background-color: #fff;
          box-shadow: 2px 2px 2px rgba(0,0,0,.1);
        }

        /**
         * White version
         *
         */
        background-color: #eee;
        border-color: #eee;
        &:hover{
          border-color: #002f5f;
        }
        &:focus{
          border-color: #002f5f;
        }
      }
      .closeSearch{
        position: absolute;
        width: 30px; height: 30px;
        border: none; border-radius: 50%;
        top: 6px; right: 10px;
        outline: 0;
        background-color: transparent;
        background-image: url(../assets/close.png);
        background-size: 12px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .6;
        display: none;
        @media (max-width: 760px) {
          display: block;
        }
      }
      button{
        position: absolute;
        width: 30px; height: 30px;
        border: none; border-radius: 50%;
        top: 5px; right: 10px;
        outline: 0;
        background-color: transparent;
        background-image: url(../assets/search.png);
        background-size: 18px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .5;

        /**
         * New
         *
         */
        top: 6px;

        @media (max-width: 760px) {
          display: none;
        }
      }
    }
    .close{
      display: none;
    }
    @media (max-width: 760px) {
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      padding: 7px 16px;
      box-sizing: border-box;
      transform: translateX(100%);
      opacity: 0;
      transition: all .3s ease;
      background-color: #fff;

      /**
       * New
       *
       */
      width: auto; margin: 0;
    }
    &.open{
      transform: none;
      opacity: 1;
    }
  }
  .logoCnt{
    display: flex;
    overflow: hidden;
    margin-right: auto;
    .logo{
      font-size: 20px;
      font-weight: bold;
      padding-right: 40px;
      margin-left: 8px;
      display: flex;
      max-width: 100%;
      a{
        color: #fff;
        white-space: nowrap;
        display: flex;
        align-items: center;
      }
      img{
        height: 38px;
        margin-right: 6px;
        margin-top: 4px;
      }
      span{
        border-left: #fff 1px solid;
        display: block;
        padding-left: 16px;
        margin-left: 10px;
        margin-top: 2px;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 140px;
        /**
         * White version
         *
         */
        color: #222;
        border-color: #ccc;
        &.span1{
          @media (max-width: 760px) {
            display: none;
          }
        }
      }
      @media (max-width: 760px) {
        padding-right: 0;
        font-size: 22px;
        img{
          height: 30px;
        }
      }
    }
  }
  .menuOverlay{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: #000;
    opacity: .6;
    z-index: 9991;
    transition: all .3s ease;
    display: none;
    @media (max-width: 1190px) {
      display: block;
    }
  }
  .menu{
    position: relative;
    display: flex;
    margin-right: 20px;
    .menuHome{
      display: none;
      margin-top: 10px;
    }
    .menuHeader{
      border-bottom: #eee 1px solid;
      height: 54px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 40px;
      font-size: 20px;
      font-weight: 600;
      position: relative;
      display: none;
      .close{
        width: 34px; height: 34px;
        border-radius: 50%;
        position: absolute;
        right: 10px; top: 10px;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    .searchInMenu{
      background-color: #eee;
      padding: 8px 20px;
      display: none;
      form{
        position: relative;
        input{
          border-radius: 50px;
          background-color: #fff;
          width: 100%;
          box-sizing: border-box;
          border: none;
          padding: 8px 14px;
          font-size: 16px;
          padding-right: 50px;
          text-overflow: ellipsis;
        }
        button{
          position: absolute;
          width: 30px;
          height: 30px;
          border: none;
          border-radius: 50%;
          top: 5px;
          right: 10px;
          outline: 0;
          background-color: transparent;
          background-image: url(../assets/search.png);
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .5;
        }
      }
    }
    @media (max-width: 1060px) {
      display: block;
      position: fixed;
      top: 0; bottom: 0;
      z-index: 9;
      background-color: #fff;
      padding: 0;
      box-shadow: 0 0 6px rgba(0,0,0,.2);
      transition: all .3s ease;
      box-sizing: border-box;
      margin: 0;
      z-index: 991;
      right: -300px; width: 300px;
      @media (max-width: 760px) {
        right: -96vw; width: 96vw;
        .searchInMenu{
          display: block;
        }
      }
      .menuHome{
        display: block;
      }
      .menuHeader{
        display: flex;
      }
    }
    .menuMoreBtn{
      display: none;
      width: 40px; height: auto;
      border: none;
      background-color: #fff;
      background-image: url(../assets/more.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 4px;
      opacity: .5; outline: 0;
      cursor: pointer;
      &:hover{
        opacity: .8;
      }
    }
    .menuMoreOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      z-index: 8; display: none;
    }
    .menuMore{
      display: flex;
    }
    @media (max-width: 1420px) {
      &.showMenuMore{
        .menuMoreOverlay{
          display: block;
        }
        .menuMore{
          display: block;
        }
      }
      .menuMoreBtn{
        display: block;
      }
      .menuMore{
        position: absolute;
        top: 100%; right: -120px;
        background-color: #fff;
        z-index: 9; display: none;
        padding: 14px 0;
        box-shadow: 2px 2px 6px rgba(0,0,0,.3);
        border-radius: 10px;
        min-width: 240px;
        li{
          a{
            font-size: 18px;
            padding: 6px 20px;
            &:before{
              display: none;
            }
            &:hover{
              background-color: #f5f5fe;
            }
            &.active{
              &:before{
                left: 0; right: auto; top: 8px; bottom: 8px;
                width: 4px; height: auto;
              }
            }
          }
        }
      }
    }
    @media (max-width: 1060px) {
      &.showMenuMore{
        .menuMoreOverlay{
          display: none;
        }
        .menuMore{
          display: none;
        }
      }
      .menuMoreBtn{
        display: none;
      }
      .menuMore{
        position: static;
        display: block;
        padding: 0;
        box-shadow: none;
        border-radius: 0;
        min-width: 0;
        li{
          a{
            font-size: 20px;
            padding: 10px 40px;
            &:hover{
              background-color: #fff;
            }
            &:before{
              display: none;
            }
            &.active{
              &:before{
                left: 0; right: auto; top: 10px; bottom: 10px;
                width: 4px; height: auto;
              }
            }
          }
        }
      }
    }
    li{
      list-style: none;
      a{
        display: block;
        text-decoration: none;
        padding: 10px 20px 9px;
        font-size: 18px;
        color: #767676;
        font-weight: 500;
        position: relative;
        white-space: nowrap;
        &:before{
          content: "";
          display: block;
          position: absolute;
          left: 0px; right: 0px;
          bottom: -12px;
          height: 4px;
        }
        &:hover{
          color: #444;
          &:before{
            background-color: #ccc;
            @media (max-width: 1060px) {
              display: none;
            }
          }
        }
        &.active{
          color: #002f5f;
          &:before{
            background-color: #002f5f;
          }
        }
        @media (max-width: 1060px) {
          font-size: 18px;
          padding: 10px 40px;
          &.active{
            &:before{
              left: 0; right: auto; top: 6px; bottom: 6px;
              width: 4px; height: auto;
            }
          }
        }
      }
    }
  }
  .signInCnt{
    display: flex;
    align-items: center;
    margin-left: 16px;
    .actIcon{
      width: 34px; height: 34px;
      border-radius: 50%;
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      opacity: .7;
      position: relative;
      margin-right: 0;
      margin-left: 15px;
      &:hover{
        background-color: #f5f5fe;
        opacity: 1;
      }
      &.search{
        margin: 0 -8px 0 20px;
        background-image: url(../assets/search.png);
        display: none;
        @media (max-width: 760px) {
          display: block;
        }
      }
      // .openSearch{
      //   position: absolute;
      //   width: 34px; height: 34px;
      //   right: 56px; top: 10px;
      //   background-image: url(../assets/search.png);
      //   background-size: 18px auto;
      //   background-position: center;
      //   background-repeat: no-repeat;
      //   display: none;
      //   opacity: .7;
      //   @media (max-width: 760px) {
      //     display: block;
      //   }
      // }
      &.menuMobile{
        background-image: url(../assets/menu.png);
        display: none;
        @media (max-width: 1190px) {
          display: block;
        }
      }
    }
    .userPict{
      margin-top: 1px;
      position: relative;
      .headerPict{
        cursor: pointer;
        width: 40px; height: 40px;
        border-radius: 50%;
        font-size: 18px;
        font-weight: normal;
        text-transform: uppercase;
        background-color: #002f5f;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        background-position: center;
        background-size: cover;
        &.hasPhoto{
          span{
            display: none;
          }
        }
        @media (max-width: 760px) {
          height: 34px; width: 34px;
          font-size: 16px;
        }
      }
      .userMenu{
        position: absolute;
        background-color: #fff;
        padding: 20px 0 10px;
        color: #444;
        right: -5px; top: 100%;
        box-shadow: 2px 2px 5px rgba(0,0,0,.4);
        width: 320px;
        box-sizing: border-box;
        text-transform: none;
        margin-top: 6px;
        border-radius: 10px;
        .pictCnt{
          display: flex;
          justify-content: center;
          margin-bottom: 10px;
          .thePict{
            width: 80px; height: 80px;
            border-radius: 50%;
            color: #fff;
            background-color: #002f5f;
            font-size: 38px;
            text-transform: uppercase;
            display: flex;
            align-items: center;
            justify-content: center;
            background-size: cover;
            background-position: center;
            &.hasPhoto{
              span{
                display: none;
              }
            }
          }
        }
        h4, h5{
          margin: 0 60px;
          font-size: 20px;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        h5{
          font-size: 15px;
          font-weight: normal;
          color: #767676;
          margin-bottom: 20px;
        }
        .infoTmp{
          background-color: yellow;
          padding: 8px 20px;
          color: #000;
          position: relative;
          b{
            font-weight: 600;
          }
        }
        li{
          list-style: none;
          padding: 10px 30px;
          cursor: pointer;
          .bl{
            float: right;
          }
          &:hover{
            background-color: #f5f5fe;
          }
          @media (max-width: 760px) {
            font-weight: 500;
            font-size: 18px;
            padding: 10px 20px;
          }
        }
        .divider{
          border-bottom: #eee 1px solid;
          margin-top: 10px;
          margin-bottom: 10px;
        }
        @media (max-width: 760px) {
          position: fixed;
          left: 0; right: 0; top: 51px; bottom: 0;
          border-radius: 0;
          box-shadow: none;
          border-top: #eee 1px solid;
          width: auto; margin: 0;
        }
      }
    }
    button.signIn{
      margin-top: -1px;
      background-color: #002f5f;
      padding: 0 24px;
      height: 42px;
      font-size: 18px;
      border-radius: 50px;
      color: #fff;
      border: none;
      font-weight: 600;
      outline: 0;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: #004c9a;
        box-shadow: 2px 2px 4px rgba(0,0,0,.2);
      }
      @media (max-width: 760px) {
        padding: 0 16px;
        margin: 1px -6px 0;
      }
    }
  }
  @media (max-width: 1060px) {
    &.showMenuMobile{
      .menu{
        right: 0;
      }
    }
  }
}
</style>
